<template>
  <div class="footer">
    <div class="footerCon maxWidth">
      <p class="footerLink">
        <router-link to="/general/about">About EZFM</router-link> |
        <router-link to="/general/jobs">Jobs</router-link> |
        <router-link to="/general/contact">Connect EZFM</router-link> |
        <router-link to="/general/privacy">Privacy Policy</router-link> |
        <a href="http://chinaplus.cri.cn" target="_blank">Links</a>
      </p>
      <p class="copyright">Copyright by EZFM Email: criezfm@cri.com.cn Registered Number: 05064898</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'footer'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .footer{
    background: #3d3e46;
    .maxWidth{width: 1165px;margin:auto;}
    .footerCon{padding: 50px 0 100px;line-height: 32px;font-size: 16px;text-align: center;}
    .footerLink , .footerLink a{color: #bababa;}
    .footerLink a:hover{color: #0085cb;}
    .copyright{color: #bababa;}
  }
  @media screen and (max-width: 900px) {
    .footer{
      .maxWidth{width: 100%;}
      .footerCon{padding-bottom: 186px;}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue